import React from 'react';
import Link from 'next/link';

interface CustomLinkProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  cypress?: string;
  stat?: string;
  href: string;
  styledLink?: React.ElementType;
  as?: string;
  prefetch?: boolean;
}

export const CustomLink: React.FC<CustomLinkProps> = ({
  cypress,
  stat,
  href,
  styledLink: StyledLink,
  children,
  onClick,
  prefetch = false,
  ...rest
}) => {
  if (!href) return null;

  if (!StyledLink) {
    return (
      <Link
        href={href}
        data-cy={cypress}
        data-stat={stat}
        onClick={onClick}
        // locale={false} prevents Next.js from auto-prefixing hrefs with locale
        // This is needed because we use subdomain-based routing (ru.bina.az)
        // and middleware rewrites, not path-based locale prefixes
        locale={false}
        prefetch={prefetch}
        {...rest}
      >
        {children}
      </Link>
    );
  }

  return (
    <StyledLink
      as={Link}
      href={href}
      data-cy={cypress}
      data-stat={stat}
      onClick={onClick}
      locale={false}
      prefetch={prefetch}
    >
      {children}
    </StyledLink>
  );
};
